// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger-module--burger--1mjpT","line":"Burger-module--line--1dLEY","box":"Burger-module--box--34wUl","burgerActive":"Burger-module--burgerActive--1cY69"};